import React, { Component } from 'react';
import BodyClassName from 'react-body-classname';

import App from './App';

export default class Page extends Component {
  componentDidMount() {
    this.props.onShowMenu();
  }

  render() {
    const { name, fluid, style, ...rest } = this.props;

    return (
      <BodyClassName className="header-invisible">
        <div className={`container${fluid ? '-fluid' : ''} page ${name} page-text no-padding`} style={style} {...rest}>
          <App />
          <div className="row no-margin">
            <div className="col-xs-12 no-padding">
              {this.props.children}
            </div>
          </div>
        </div>
      </BodyClassName>
    );
  }
}

Page.defaultProps = {
  name: '',
  fluid: false,
  onShowMenu: () => {},
  style: {},
};



// WEBPACK FOOTER //
// ./src/components/Page.js